import React, { ReactNode, useState } from 'react';
import { useTheme } from 'styled-components';

import { Icon } from '../Icon';
import { Text } from '../Text';
import { AlertContainerProps, StyledText, StyledWrapper } from './Alert.style';

export interface AlertProps {
  message: string | ReactNode;
  type: AlertContainerProps['type'];
  closable?: boolean;
}

export const alertIcons = {
  success: 'checkbox---circle',
  error: 'alert---triangle',
  warning: 'alert-info',
  info: 'alert-info',
};

export function Alert({ message, type, closable }: AlertProps) {
  const theme = useTheme();
  const [visible, setVisible] = useState(true);

  const themeIcons = {
    ...alertIcons,
    info: theme.Components.Alert.Info.Icon,
  };

  if (!visible) {
    return null;
  }

  return (
    <StyledWrapper type={type}>
      <Icon name={themeIcons[type]} size="Medium" />
      <StyledText>
        <Text size={'Small'}>{message}</Text>
      </StyledText>
      {closable && <Icon name="cross" size="Small" onClick={() => setVisible(false)} />}
    </StyledWrapper>
  );
}
